import * as React from "react";
import { Box } from "grid-styled";
import { Route, Redirect, Switch } from "react-router-dom";
import Dashboard from "./Dashboard/";
import Reports from "./Reports";
import Report from "../Report";
import queryString from "query-string";
import DailySalesReport from "../reports/DailySalesReport";
import SalesBySalespersonReport from "../reports/SalesBySalespersonReport";
import MonthlySalesReport from "../reports/MonthlySalesReport";
import Jobs from "../Jobs";
import Job from "../Job";
import Franchises from "../Franchises";
import Franchise from "../Franchise";
import NewFranchise from "../NewFranchise";
import Users from "../Users";
import Holidays from "../Holidays";
import UserNew from "../UserNew";
import UserEdit from "../UserEdit";
import NewJob from "../NewJob";
import SearchResults from "../SearchResults";
import TransmittalTemplates from "../TransmittalTemplates";
import join from "../../utils/join-path";
import CenteredLoader from "../CenteredLoader";
import withCurrentUser from "../../hocs/withCurrentUser";

const AdminRoutes = ({ match, userData }) => {
  if (userData.loading) {
    return <CenteredLoader />;
  }

  // If not an admin...
  if (!userData.isAdminUser) {
    return <Redirect to="/" />;
  }

  return (
    <Switch>
      <Redirect exact path={match.path} to={join(match.url, "/dashboard")} />
      <Route path={`${match.path}/dashboard`} component={Dashboard} />
      <Route
        path={`${match.path}/search`}
        render={({ match, location }) => {
          const query = queryString.parse(location.search);
          return (
            <Box p={3}>
              <SearchResults match={match} q={query.q} />
            </Box>
          );
        }}
      />
      <Route path={`${match.path}/jobs`} exact component={Jobs} />
      <Route path={`${match.path}/jobs/new`} component={NewJob} />
      <Route path={`${match.path}/jobs/:jobId`} component={Job} />
      <Route path={`${match.path}/reports`} exact component={Reports} />
      <Route
        path={`${match.path}/reports/daily-sales`}
        component={DailySalesReport}
      />
      <Route
        path={`${match.path}/reports/monthly-sales-by-franchise`}
        component={MonthlySalesReport}
      />
      <Route
        path={`${match.path}/reports/sales-by-salesperson`}
        component={SalesBySalespersonReport}
      />
      <Route
        path={`${match.path}/reports/cancelled`}
        render={props => <Report reportSlug="cancelled" />}
      />
      <Route path={`${match.path}/reports/:reportSlug`} component={Report} />
      <Route path={`${match.path}/franchises`} exact component={Franchises} />
      <Route path={`${match.path}/franchises/new`} component={NewFranchise} />
      <Route
        path={`${match.path}/franchises/:franchiseId`}
        component={Franchise}
      />
      <Route
        path={`${match.path}/transmittal-templates`}
        component={TransmittalTemplates}
      />
      <Route path={`${match.path}/users`} exact component={Users} />
      <Route path={`${match.path}/users/new`} exact component={UserNew} />
      <Route path={`${match.path}/users/:userId`} component={UserEdit} />
      <Route path={`${match.path}/holidays`} exact component={Holidays} />
    </Switch>
  );
};

export default withCurrentUser()(AdminRoutes);



// WEBPACK FOOTER //
// ./src/components/admin/Routes.js